// A skill file's preview (D62): the shared Markdown renderer, reading SKILL.md's front matter.
import { useT } from "../i18n";
import { Markdown } from "../ui/markdown/Markdown";

export function MarkdownPreview({ source }: { source: string }) {
  const t = useT().skills.files;
  return (
    <Markdown
      source={source}
      frontMatter={t.frontMatter}
      label={t.preview}
      className="text-gray-700"
      empty={<p className="m-0 text-[13px] text-gray-500">{t.nothingToPreview}</p>}
    />
  );
}
